import React from 'react';
import { Link } from "gatsby";
import * as Icon from 'react-feather';

const PeraOzellikler = () => {
    return (
        <div className="features-area pt-80 pb-50 bg-f9f6f6">
            <div className="container">
                <div className="section-title">
                    <h2>Özellikler</h2>
                    <div className="bar"></div>
                    <p>50+ Personelli 3-2-1 vardiya usulüyle çalışan fabrikalarda parmak izi veya yüz tanıma cihazlarından bilgi alarak çalışma takvimi planlamadan otomatik olarak vardiya seçimi yapar, analiz eder, mola sürelerini takip eder ve bordro puantajı oluşturur  </p>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon">
                                <Icon.Settings />
                            </div>
                            <h3>
                                <Link to="/feature-details">
                                    Çalışma Takvimini Planlamanıza Gerek Yok
                                </Link>
                            </h3>
                            <p>Yapay zeka destekli personelin geldiği vardiyayı pera otomatik seçer. İdari, Meydancı, Ahçı vb vardiyalarını ayırabilirsiniz</p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon">
                                <Icon.Mail />
                            </div> 
                            <h3>
                                <Link to="/feature-details">
                                   Tek Tuşla Bordro Puantajı
                                </Link>
                            </h3>
                            <p>Ay sonunda tek tuşla bordro puantajını alabilirsiniz. Mevcut muhasebe programına aktarıp bordro işlemlerini hızlıca yapabilirsiniz</p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon bg-c679e3">
                                <Icon.Grid />
                            </div>
                            <h3>
                                <Link to="/feature-details">
                                   Giriş / Çıkış Takibi
                                </Link>
                            </h3>
                            <p>Personelin giriş çıkışlarını okutmalarına göre analiz eder. Eğer okutma unutulmuşsa gün kapatma ekranından sanal okutma girebilirsiniz</p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon bg-c679e3">
                                <Icon.Info />
                            </div>
                            <h3>
                                <Link to="/feature-details">
                                 Mola Takibi
                                </Link>
                            </h3>
                            <p>Üretim alanını giriş çıkışını kısıtlayarak, günde kaç kez molaya çıkılmış kaç dakika çıkılmış otomatik analiz eder</p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon bg-eb6b3d">
                                <Icon.Box />
                            </div>
                            <h3>
                                <Link to="/feature-details">
                                    İzin Takibi
                                </Link>
                            </h3>
                            <p>Resmi izinler, yıllık izin, ücretli, ücretsiz, rapor doğum ölüm izinlerini buradan takip edebilirsiniz</p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon bg-eb6b3d">
                                <Icon.Bell />
                            </div>
                            <h3>
                                <Link to="/feature-details">
                                    Devamsızlık Takibi
                                </Link>
                            </h3>
                            <p>Personel gelmediğinde sizi uyarır. Devamsızlığını takip eder. Tam çalışma hakedişini hesaplar</p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon">
                                <Icon.Settings />
                            </div>
                            <h3>
                                <Link to="/feature-details">
                                    Fazla Mesai Hesaplama
                                </Link>
                            </h3>
                            <p>Personel bazlı farklı fazla mesai hesaplama yöntemlerine uyarlanabilir parametrik yapıda fazla mesai hesabı yapabilirsiniz</p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                        <div className="single-features">
                            <div className="icon">
                                <Icon.Mail />
                            </div> 
                            <h3>
                                <Link to="/feature-details">
                                   Performans Analizleri & Raporlar
                                </Link>
                            </h3>
                            <p>Personel bazlı veya aylık bazda izin mola çalışma performansı analizi yapar. Ayrıca tüm raporlara hızlıca ulaşabilirsiniz</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PeraOzellikler;  